
export const Chest = () => {
  return (
    <div id='category'>
      <div className="row">
        <div className="col-xs-12 col-md-6">
          <div className="about-text">
            <h2>HIDDEN CHESTS</h2>
            <h4>The Founder left lots of notes of his adventures but not all of them are related to the main story, some of them guides you to hidden chests around The Galgon Earth. What do these chests contains inside? ADA! You can find chests of 100, 200, 500, 1000 ADA or even more....</h4>
            <h4>Navigate through the Galgon Earth map in the Greyhound App, visit places and collect the words that belong to Cardano addresses, find and unlock them to retrieve the prize!.</h4>
          </div>
        </div>
        <div className="col-xs-12 col-md-6" style={{display: 'flex', justifyContent: 'center'}}>
          <img src={'./img/chest.png'} className="img-responsive" alt="" />{" "}
        </div>
      </div>
    </div>
  )
}
